var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43329_77927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.770576 17.7825C0.769732 20.8072 1.56623 23.7606 3.08076 26.3637L0.625732 35.258L9.79898 32.8714C12.3362 34.2419 15.1789 34.96 18.0677 34.9602H18.0753C27.6118 34.9602 35.3747 27.2603 35.3788 17.796C35.3806 13.2099 33.5823 8.89747 30.3151 5.653C27.0483 2.40882 22.7037 0.621234 18.0746 0.619141C8.53702 0.619141 0.774654 8.31868 0.770717 17.7825",
    fill: "url(#paint0_linear_43329_77927)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.150469 17.779C0.149484 20.9125 0.974531 23.9715 2.54306 26.6679L0 35.881L9.50217 33.4088C12.1203 34.8253 15.0681 35.572 18.0676 35.5732H18.0754C27.954 35.5732 35.9958 27.5962 36 17.7932C36.0017 13.0423 34.1387 8.57484 30.7547 5.21414C27.3703 1.85386 22.8703 0.00195349 18.0754 0C8.19506 0 0.154406 7.97581 0.150469 17.779ZM5.80936 26.2035L5.45456 25.6447C3.96309 23.2916 3.17587 20.5723 3.177 17.7801C3.18009 9.63195 9.86316 3.00279 18.081 3.00279C22.0607 3.00447 25.8007 4.54381 28.6138 7.33674C31.4267 10.13 32.9746 13.843 32.9736 17.7921C32.97 25.9402 26.2867 32.5702 18.0754 32.5702H18.0695C15.3958 32.5688 12.7735 31.8564 10.4867 30.51L9.94247 30.1898L4.30369 31.6567L5.80936 26.2035Z",
    fill: "url(#paint1_linear_43329_77927)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5928 10.3485C13.2573 9.60856 12.9042 9.59363 12.5851 9.58065C12.3238 9.56949 12.0251 9.57033 11.7267 9.57033C11.428 9.57033 10.9427 9.68182 10.5325 10.1262C10.1219 10.5711 8.96484 11.646 8.96484 13.8324C8.96484 16.0188 10.5698 18.1319 10.7935 18.4287C11.0175 18.7249 13.8919 23.3553 18.4442 25.1366C22.2276 26.6169 22.9975 26.3225 23.8186 26.2482C24.6399 26.1743 26.4686 25.1735 26.8417 24.1358C27.215 23.0982 27.215 22.2088 27.1031 22.023C26.9911 21.8378 26.6925 21.7266 26.2446 21.5045C25.7967 21.2823 23.5946 20.2071 23.1841 20.0587C22.7735 19.9106 22.475 19.8366 22.1763 20.2816C21.8776 20.7259 21.0199 21.7266 20.7585 22.023C20.4974 22.32 20.2359 22.357 19.7882 22.1347C19.34 21.9118 17.8976 21.4431 16.1864 19.9293C14.8549 18.7513 13.956 17.2967 13.6948 16.8517C13.4335 16.4074 13.6668 16.1666 13.8914 15.9451C14.0926 15.746 14.3394 15.4262 14.5635 15.1668C14.7869 14.9073 14.8614 14.7221 15.0107 14.4257C15.1602 14.1291 15.0854 13.8695 14.9736 13.6473C14.8614 13.425 13.9911 11.2272 13.5928 10.3485Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43329_77927",
    x1: 1738.28,
    y1: 3464.5,
    x2: 1738.28,
    y2: 0.619141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43329_77927",
    x1: 1800,
    y1: 3588.1,
    x2: 1800,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43329_77927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.969cb4023aca7380d7b60676b81a75a5.svg";
export { ForwardRef as ReactComponent };